<template>
  <div style="height: 100%">
    <!-- <div style="width: 200px; position: absolute; z-index: 20"> -->
    <div style="width: 200px; position: absolute; z-index: 20">
      <Float_menu />
    </div>
    <div ref="Server_Stor" style="height: 100%"></div>
  </div>
</template>

  <script>
import * as echarts from "echarts";
// import { getTopoData } from "../utils/topo_utils";
import { Url, grafana_Url, tooltip_basecss } from "../config/env";
import Float_menu from "../views/Float_menu";

export default {
  data() {
    return {
      mychartOptions: {},
      chartWidth: 1720,
      chartHeight: 900,
      symbolSizeTimes: 1,
      envData: {
        colors: {
          status_colors: ["#4301E6", "orange", "#DC251F"],
          border_colors: ["grey", "orange"],
        },
        lineTag: {
          c_1g: {
            lineColor: "#666",
            lineWidth: 5,
            lineType: "dashed",
          },
          f_1g: {
            lineColor: "orange",
            lineWidth: 5,
            lineType: "dashed",
          },
          f_10g: {
            lineColor: "red",
            lineWidth: 5,
            lineType: "dashed",
          },
        },
        nodeSymbolsize: {
          nutanix: [55, 45],
          switch: [55, 45],
          storage: [45, 72],
          vmware: [55, 45],
          aix: [80, 58],
        },
      },
    };
  },
  components: {
    Float_menu,
  },
  // watch: {
  //   chartWidth(chartWidth) {
  //     this.symbolSizeTimes = (this.chartWidth / 1720).toFixed(1);
  //   },
  // },
  methods: {
    getTopoData: async function (topo_name, env_Data) {
      let options = {};
      //获取全局变量
      const status_colors = env_Data.colors.status_colors;
      var border_colors = env_Data.colors.border_colors;
      // 获取图中主机数据
      const hosts_file = Url + "topo_data/" + topo_name + "/hosts_obj.json";
      const lines_file = Url + "topo_data/" + topo_name + "/lines_obj.json";
      // const borders_file = Url + "topo_data/" + topo_name + "/borders_obj.json";
      const borders1_file =
        Url + "topo_data/" + topo_name + "/borders1_obj.json";
      // const [hosts_data, lines_data, borders_data, borders1_data] =
      const [hosts_data, lines_data, borders1_data] = await Promise.all([
        fetch(hosts_file),
        fetch(lines_file),
        // fetch(borders_file),
        fetch(borders1_file),
      ]);
      const hostsData = await hosts_data.json();
      const linesData = await lines_data.json();
      // const bordersData = await borders_data.json();
      const bordersData1 = await borders1_data.json();
      const hosts = hostsData["data"];
      const lines = linesData["data"];
      // const borders = bordersData["data"];
      const borders1 = bordersData1["data"];
      let charts = {
        hosts: [],
        lines: [],
        lines_1: [],
        // borders: [],
        borders1: [],
      };
      //  生成节点数据
      for (let key in hosts) {
        //定义tooltip中的信息
        let tooltip_info = "信息暂无";
        // let problem_info = "系统正常"
        let tooltip_list = hosts[key]["item_info"];
        let problem_obj = hosts[key]["problems"];
        if (Object.keys(tooltip_list).length != 0) {
          tooltip_info = "";
          for (let item of tooltip_list) {
            tooltip_info +=
              '<div><span style="color:gray">' +
              Object.keys(item) +
              "&nbsp" +
              '</span>:<span style="color:green">' +
              "&nbsp" +
              Object.values(item) +
              "</></div>";
          }
        }
        //加入故障信息
        if (Object.keys(problem_obj).length != 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (let i in problem_obj) {
            if (problem_obj[i]["priority"] <= 3) {
              tooltip_info +=
                '<div style="color:orange">' +
                n +
                "." +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            } else {
              tooltip_info +=
                '<div style="color:red">' +
                n +
                "." +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            }
          }
        } else {
          tooltip_info += '<div style="color:green">系统正常</div>';
        }
        let node = {
          name: hosts[key]["nodeName"],
          value: hosts[key]["coords"],
          symbolSize: [
            this.envData.nodeSymbolsize[hosts[key]["pngPath"]][0] *
              this.symbolSizeTimes,
            this.envData.nodeSymbolsize[hosts[key]["pngPath"]][1] *
              this.symbolSizeTimes,
          ],
          // symbolSize: hosts[key]["symbolSize"].split(","),
          // symbolSize: [65, 65],
          nodeStatus: hosts[key]["nodeStatus"],
          symbol:
            "image://" +
            Url +
            "/topo_data/" +
            topo_name +
            "/" +
            hosts[key]["pngPath"] +
            "_" +
            hosts[key]["nodeStatus"] +
            ".png",
          // itemStyle: {
          //   color: status_colors[hosts[key]["nodeStatus"]],
          // },
          // label: {
          //     show: hosts[key]["labelShow"] == true,
          //     position: "bottom",
          //     color: "#4301E6",
          //     fontFamily: "Arial",
          //     fontSize: 15,
          //     formatter: hosts[key]["nodeName"]
          // },
          tooltip: tooltip_info,
          url1:
            hosts[key]["url1"][0] == "#"
              ? Url + hosts[key]["url1"]
              : grafana_Url[hosts[key]["url1"]] +
                "&var-HOST=" +
                hosts[key]["zabbix_hostname"],
          url2:
            hosts[key]["url2"][0] == "#"
              ? Url + hosts[key]["url2"]
              : hosts[key]["url2"],
          click_redirect: "true",
        };
        charts.hosts.push(node);
      }
      // 生成连线数据
      for (let key in lines) {
        //定义tooltip中的信息
        let tooltip_info = "信息暂无";
        //用一个变量存储线条效果状态
        let effectShow = 0;
        // let problem_info = "状态正常"
        let tooltip_obj = lines[key]["item_info"];
        let problem_obj = lines[key]["problems"];

        if (Object.keys(tooltip_obj).length != 0) {
          tooltip_info = "";
          for (let i in tooltip_obj) {
            tooltip_info +=
              '<div style="color:green">' + i + ":" + tooltip_obj[i] + "</div>";
            // 根据流量判断effectShow
            let tooltip_unit_list = tooltip_obj[i].split(" ");
            if (
              (parseFloat(tooltip_unit_list[0]) > 1500 &&
                ["mb/s"].includes(tooltip_unit_list[1]) > 0) |
              (["gb/s", "tb/s"].includes(tooltip_unit_list[1]) > 0)
            ) {
              // console.log(parseFloat(tooltip_unit_list[0]));
              effectShow = 1;
            }
          }
        }
        //加入故障信息
        if (Object.keys(problem_obj).length != 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (let i in problem_obj) {
            if (problem_obj[i]["priority"] <= 3) {
              tooltip_info +=
                '<div style="color:orange">' +
                n +
                "." +
                problem_obj[i] +
                "</div>";
              n += 1;
            } else {
              tooltip_info +=
                '<div style="color:red">' + n + "." + problem_obj[i] + "</div>";
              n += 1;
            }
          }
        } else {
          tooltip_info += '<div style="color:green">状态正常</div>';
        }

        let line = {
          // polyline: true,
          lineName: lines[key]["lineName"],
          coords: lines[key]["coords"],
          // lineStatus: lines[key]["lineStatus"],
          lineStatus: lines[key]["lineStatus"],
          effectShow: effectShow,
          lineStyle: {
            width:
              lines[key]["lineWidth"].length > 0
                ? lines[key]["lineWidth"]
                : null,
            opacity:
              lines[key]["lineOpacity"].length > 0
                ? lines[key]["lineOpacity"]
                : null,
            // curveness:
            //   lines[key]["lineCurveness"].length > 0
            //     ? lines[key]["lineCurveness"]
            //     : null,
            color:
              lines[key]["lineColor"].length > 0
                ? lines[key]["lineColor"]
                : null,
            type:
              lines[key]["lineType"].length > 0 ? lines[key]["lineType"] : null,
          },
          tooltip: tooltip_info,
          url1: grafana_Url["item_url"] + lines[key]["items"],
          click_redirect: "true",
        };
        line["effectShow"] == 1
          ? charts.lines_1.push(line)
          : charts.lines.push(line);
      }
      //  生成边框数据
      // for (let key in borders) {
      //   let node = {
      //     name: borders[key]["borderName"],
      //     value: borders[key]["coords"],
      //     // symbol: 'path://' + hosts[key]['shape'],
      //     itemStyle: {
      //       color: border_colors[borders[key]["color"]],
      //       borderColor: "white",
      //       opacity: 0.72,
      //     },
      //   };
      //   charts.borders.push(node);
      // }
      //  生成边框1数据
      for (let key in borders1) {
        let line = {
          lineName: borders1[key]["borderName"],
          coords: borders1[key]["coords"],
          lineStyle: {
            color: borders1[key]["borderColor"],
            width: 6,
            opacity: 1,
          },
          click_redirect: "true",
        };
        charts.borders1.push(line);
      }
      return charts;
    },
    makeChartOption(chartData) {
      let options = {
        backgroundColor: "#111217",
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          // width: 1720,
          // height: 900,
        },
        xAxis: {
          min: 0,
          max: this.chartWidth,
          show: false,
          type: "value",
        },
        yAxis: {
          min: 0,
          max: this.chartHeight,
          show: false,
          inverse: true,
          type: "value",
        },
        tooltip: tooltip_basecss,
        graphic: {
          // id: "aa",
          elements: [
            {
              type: "text",
              left: "48%",
              top: "92%",
              style: {
                text: "综合5F中心机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: "grey",
              },
            },
            {
              type: "text",
              left: "61%",
              top: "92%",
              style: {
                text: "后勤5F冗余机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: "grey",
              },
            },
          ],
        },
        series: [
          ///节点数据
          {
            type: "graph",
            coordinateSystem: "cartesian2d",
            // roam: true,
            layout: "none",
            emphasis: {
              // disabled: true,
              scale: 1.4,
              // focus: 'self',
              // blurScope: 'global'
            },
            label: {
              show: true,
              position: "bottom",
              color: "#666",
              fontFamily: "serif",
              fontWeight: "bold",
              fontSize: 15,
              formatter: function (item) {
                return item.data.name;
              },
            },
            data: chartData.hosts,
            // zoom: 2,
            zlevel: 3,
          },

          // 连接线条数据
          // 无线条效果
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            emphasis: {
              disabled: false,
              focus: "none",
              blurScope: "global",
              lineStyle: {
                type: "solid",
                color: "red",
                // width: 6,
                zlevel: 2,
              },
            },
            lineStyle: {
              color: "grey",
              show: true,
              width: 3,
              type: "dashed",
              // opacity: 0.1,
              // curveness: 0.3,
            },
            effect: {
              show: false,
              // loop: true,
              // roundTrip: true,
              period: 2, // 图标飞跃速度，值越小速度越快
              trailLength: 0.2, // 尾迹长度[0,1]值越大，尾迹越长
              symbol: "diamond", // 图标类型
              symbolSize: 8, // 图标大小
              color: "white", // 图标颜色
            },
            data: chartData.lines,
            zlevel: 2,
          },
          // 有线条效果
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            emphasis: {
              disabled: false,
              focus: "none",
              blurScope: "global",
              lineStyle: {
                type: "solid",
                // color: "red",
                width: 6,
                zlevel: 2,
              },
            },
            lineStyle: {
              color: "grey",
              show: true,
              width: 4,
              type: "dashed",
              // opacity: 0.1,
              // curveness: 0.3,
            },
            effect: {
              show: true,
              // loop: true,
              // roundTrip: true,
              period: 2, // 图标飞跃速度，值越小速度越快
              trailLength: 0.2, // 尾迹长度[0,1]值越大，尾迹越长
              symbol: "diamond", // 图标类型
              symbolSize: 8, // 图标大小
              color: "white", // 图标颜色
            },
            data: chartData.lines_1,
            zlevel: 2,
          },
          //边框信息
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            // colorBy: "white",
            tooltip: {
              show: true,
              position: function (point) {
                return point[0];
              },
              color: "red",
              formatter: function (item) {
                return item.data.lineName;
              },
            },
            // emphasis: {
            //   // disabled: false,

            //   // focus: 'self',
            //   // blurScope: 'global',
            //   lineStyle: {
            //     type: "solid",
            //     width: 5,
            //     // curveness: 0.1,
            //   },
            // },
            lineStyle: {
              // type: 5,
              cap: "round",
              type: "dashed",
              width: 2,
            },
            emphasis: {
              disabled: false,
              width: 2,
              lineStyle: {
                // type: 5,
                cap: "round",
                type: "solid",
                width: 4,
              },
            },
            data: chartData.borders1,
            zlevel: 1,
          },
        ],
      };
      return options;
    },
    maketopo: async function (topo_name) {
      let myChart = echarts.init(this.$refs[topo_name]);
      //获取数据
      let myChartData = await this.getTopoData(topo_name, this.envData);
      //定义options
      this.mychartOptions = this.makeChartOption(myChartData);
      //渲染页面
      // console.log(this.mychartOptions);
      myChart.setOption(this.mychartOptions);
      // //故障节点动画效果
      // setInterval(() => {
      //   console.log(this.mychartOptions.series[0].data);
      //   for (let i in this.mychartOptions.series[0].data) {
      //     if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
      //       this.mychartOptions.series[0].data[i]["symbolSize"][0] *= 1.2;
      //       this.mychartOptions.series[0].data[i]["symbolSize"][1] *= 1.2;
      //     }
      //   }
      //   myChart.setOption(this.mychartOptions);
      //   setTimeout(() => {
      //     for (let i in this.mychartOptions.series[0].data) {
      //       if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
      //         this.mychartOptions.series[0].data[i]["symbolSize"][0] /= 1.2;
      //         this.mychartOptions.series[0].data[i]["symbolSize"][1] /= 1.2;
      //       }
      //     }
      //     myChart.setOption(this.mychartOptions);
      //   }, 1000);
      // }, 2000);
      // 故障线条动画效果
      setInterval(() => {
        if (this.mychartOptions.series[1].data.length > 0) {
          for (let i in this.mychartOptions.series[1].data) {
            if (this.mychartOptions.series[1].data[i]["lineStatus"] != 0) {
              // this.mychartOptions.series[1].data[i]["lineStyle"]["type"] = "solid";
              this.mychartOptions.series[1].data[i]["lineStyle"][
                "width"
              ] *= 1.5;
              this.mychartOptions.series[1].data[i]["lineStyle"]["color"] =
                "red";
              this.mychartOptions.series[1].data[i]["zlevel"] = 4;
            }
          }
        }
        if (this.mychartOptions.series[2].data.length > 0) {
          for (let i in this.mychartOptions.series[2].data) {
            if (this.mychartOptions.series[2].data[i]["lineStatus"] != 0) {
              // this.mychartOptions.series[1].data[i]["lineStyle"]["type"] = "solid";
              this.mychartOptions.series[2].data[i]["lineStyle"][
                "width"
              ] *= 1.5;
              this.mychartOptions.series[2].data[i]["lineStyle"]["color"] =
                "red";
              this.mychartOptions.series[2].data[i]["zlevel"] = 4;
            }
          }
        }
        myChart.setOption(this.mychartOptions);

        setTimeout(() => {
          if (this.mychartOptions.series[1].data.length > 0) {
            for (let i in this.mychartOptions.series[1].data) {
              if (this.mychartOptions.series[1].data[i]["lineStatus"] != 0) {
                // this.mychartOptions.series[1].data[i]["lineStyle"]["type"] = "dashed";
                this.mychartOptions.series[1].data[i]["lineStyle"][
                  "width"
                ] /= 1.5;
                this.mychartOptions.series[1].data[i]["lineStyle"]["color"] =
                  "grey";
                this.mychartOptions.series[1].data[i]["zlevel"] = 3;
              }
            }
          }
          if (this.mychartOptions.series[2].data.length > 0) {
            for (let i in this.mychartOptions.series[2].data) {
              if (this.mychartOptions.series[2].data[i]["lineStatus"] != 0) {
                // this.mychartOptions.series[1].data[i]["lineStyle"]["type"] = "dashed";
                this.mychartOptions.series[2].data[i]["lineStyle"][
                  "width"
                ] /= 1.5;
                this.mychartOptions.series[2].data[i]["lineStyle"]["color"] =
                  "grey";
                this.mychartOptions.series[2].data[i]["zlevel"] = 3;
              }
            }
          }
          myChart.setOption(this.mychartOptions);
        }, 1000);
      }, 2000);
      let click_type = null; // 定义一个定时器
      myChart.on("click", (data) => {
        if (!click_type) {
          click_type = setTimeout(() => {
            window.location.assign(data.data.url1);
            click_type = null; // 清除定时器
          }, 300);
        } else {
          window.open(data.data.url2);
          clearTimeout(click_type); // 清除定时器
          click_type = null;
        }
      });
      setInterval(async () => {
        // myChart.setOption(
        //   this.makeChartOption(
        //     await this.getTopoData("Server_Stor", this.envData)
        //   )
        // );
        this.mychartOptions = this.makeChartOption(
          await this.getTopoData("Server_Stor", this.envData)
        );
        // myChart.setOption(this.mychartOptions);
      }, 60000);
      window.onresize = function () {
        myChart.resize();
        this.chartWidth = myChart.getDom().clientWidth;
        this.chartHeight = myChart.getDom().clientHeight;
      };
    },
  },
  mounted() {
    this.maketopo("Server_Stor");
  },
};
</script>
  <style lang="less" scoped>
@import "../style/mixin";
</style>
  
